import React from "react";

import { Bars3BottomLeftIcon } from "@heroicons/react/24/outline";
import loadable from "@loadable/component";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import constants from "@/utils/constants";

const MerchantAndOutletLabel = loadable(() =>
  import("./MerchantAndOutletLabel"),
);
const OutletStatusSelector = loadable(() => import("./OutletStatusSelector"));
const ProfileDropdown = loadable(() => import("./ProfileDropdown"));

Header.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  sidebarVisible: PropTypes.bool,
  setSidebarVisible: PropTypes.func,
};

export default function Header({
  children,
  sidebarVisible,
  setSidebarVisible,
}) {
  const { t } = useTranslation();
  return (
    <div className="relative z-10 flex flex-shrink-0 h-16 bg-white border-b border-gray-200">
      <button
        className="px-4 text-gray-500 border-r border-gray-200 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
        onClick={() => setSidebarVisible(!sidebarVisible)}
      >
        <span className="sr-only">{t("header.openSidebarSr")}</span>
        <Bars3BottomLeftIcon className="w-6 h-6" />
      </button>
      <div className="flex justify-between flex-1 px-4 xl:px-0 xl:ml-4 xl:mr-4">
        <h3
          className="flex flex-col items-start justify-center flex-1 mb-0 text-lg font-semibold truncate"
          data-testid="header-content-container"
        >
          <MerchantAndOutletLabel />
          {children}
        </h3>
        <div className="flex space-x-4">
          <OutletStatusSelector />
          <div className="flex items-center ml-4 xl:ml-6">
            <span className="hidden mr-3 lg:block">
              {localStorage.getItem(constants.ACCOUNT_EMAIL)}
            </span>
            <ProfileDropdown />
          </div>
        </div>
      </div>
    </div>
  );
}
